<div class="modal-body">
    @if (consumptionAgentTranslated$ | async; as consumptionAgentTranslated) {
        <app-consumption-agent-result
            [previewConsumptionAgentRequest]="
                consumptionAgentTranslated
            "></app-consumption-agent-result>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
        {{ 'reporting_CLOSE' | translate }}
    </button>
</div>
